import { observer, inject } from 'mobx-react'
import { useTheme } from '@emotion/react'

import { ActionMenu, SVGWrapper } from '../../../components'
import { PiggyBank, Warning } from '../../../assets/icons'
import { numberToDollars, withRouterProps } from '../../../utils'
import { planTypeIdToAccountKey } from '../../../constants'
import { getParticipantName } from '../utils'
import {
  SectionBalance,
  DollarSign,
  SectionRow,
  SectionLabel,
  AccountNameLink,
  NameMarker,
  SectionSubLabel,
  NameField,
  BalanceField,
  SVGContainer,
  WarningContainer,
  WarningMessage,
  ReviewButton,
} from './DashboardStyle'

const typeToPathKey = {
  Annuity: 'annuity',
  Institutional: 'institutional',
  NonGc: 'non-gc',
  Pension: 'pension',
}

function DashboardEmployerSponsoredAccount({ account, id: rowId, main, navigate, store }) {
  const {
    features,
    account: { managedAccount },
    config: { templateId },
    institutionalAccount,
    institutionalAccountUnderReview,
  } = store
  const { id, name, balance, type, planType, participantId, contributing } = account
  const theme = useTheme()

  const accountType = planTypeIdToAccountKey[planType]

  // Match the account check used by the review flow so the prompt only appears for that account.
  const needsReview = Boolean(institutionalAccountUnderReview) && id === institutionalAccount?.id

  // only atmos institutional pensions
  const canEdit = templateId === 4 && type === 'Pension'
  const showManagedMarker =
    type === 'Institutional' && features.managedAccountAvailable && managedAccount

  function handleOpenAccount() {
    navigate(`/accounts/${typeToPathKey[type]}/${accountType}/${id}`)
  }

  function handleRetirementAccountReview() {
    main.setSidebar(false)
    navigate(`/accounts/add/${typeToPathKey[type]}/${accountType}/intro`, { state: { id } })
  }

  return (
    <div>
      <SectionRow id={rowId}>
        <NameField>
          <SectionLabel>
            <AccountNameLink type='button' onClick={handleOpenAccount}>
              {name}
            </AccountNameLink>
            {showManagedMarker && <NameMarker>*</NameMarker>}
          </SectionLabel>
          <SectionSubLabel>{getParticipantName(store, participantId)}</SectionSubLabel>
        </NameField>
        <BalanceField>
          {contributing && (
            <SVGWrapper
              svg={PiggyBank}
              fill={theme.lightestGray}
              hoverFill={theme.lightestGray}
              size='medium'
              cursor='default'
            />
          )}
          <SectionBalance>
            <DollarSign>$</DollarSign>
            {numberToDollars(balance, true)}
          </SectionBalance>
          <ActionMenu
            items={[{ label: canEdit ? 'Edit' : 'View', onClick: handleOpenAccount }]}
            ariaLabel={`Actions for ${name}`}
          />
        </BalanceField>
      </SectionRow>
      {needsReview && (
        <WarningContainer>
          <WarningMessage>
            <SVGContainer>
              <SVGWrapper svg={Warning} fill='#3A4D57' size='large' />{' '}
            </SVGContainer>
            <div>
              Please review and complete any missing information for this account.{' '}
              <ReviewButton type='button' onClick={handleRetirementAccountReview}>
                Review account
              </ReviewButton>
            </div>
          </WarningMessage>
        </WarningContainer>
      )}
    </div>
  )
}

export default withRouterProps(inject('store', 'main')(observer(DashboardEmployerSponsoredAccount)))
